// extracted by mini-css-extract-plugin
export default {"updateImg":"Ballance_updateImg__q05HT","spin":"Ballance_spin__REe18","spintd":"Ballance_spintd__FfLtV"};